<template>
    <div>
        <div v-if="view == 1">
            <b-list-group>
                <b-list-group-item v-for="item in visibleHistory"
                                   :key="item.id"
                                   class="d-flex flex-column">
                    <div>
                        <strong>{{ item.statusPath }}</strong>
                        <b-badge v-if="item.isLegacy"
                                 variant="warning"
                                 class="ml-2">
                            Legacy
                        </b-badge>
                    </div>

                    <div v-if="item.reasonName">
                        Reason: {{ item.reasonName }}
                    </div>

                    <small class="text-muted">
                        {{ formatDate(item.createdDate) }}

                        <span v-if="item.createdBy">
                            by {{ item.createdBy }}
                        </span>

                    </small>
                </b-list-group-item>
            </b-list-group>

            <div class="text-center mt-2" v-if="items.length > 3">
                <b-button size="sm" variant="link" @click="showAllHistory = !showAllHistory">
                    {{ showAllHistory ? 'Show Less' : 'Show Full History' }}
                </b-button>
            </div>
        </div>
        <div v-else-if="view == 2">
            <b-list-group>

                <!-- Latest status (highlighted) -->
                <b-list-group-item v-if="items.length"
                                   class="bg-light border-primary">
                    <strong>Current:</strong> {{ items[0].statusPath }}
                    <b-badge v-if="items[0].isLegacy"
                             variant="warning"
                             class="ml-2">
                        Legacy
                    </b-badge><br>

                    <span v-if="items[0].reasonName">
                        {{ items[0].reasonName }}
                    </span>

                    <br>
                    <small>
                        {{ formatDate(items[0].createdDate) }}

                        <span v-if="items[0].createdBy">
                            by {{ items[0].createdBy }}
                        </span>

                    </small>
                </b-list-group-item>

                <!-- Previous statuses -->
                <b-collapse v-model="showAllHistory">
                    <b-list-group-item v-for="item in items.slice(1)"
                                       :key="item.id">
                        {{ item.statusPath }}
                        <b-badge v-if="items[0].isLegacy"
                                 variant="warning"
                                 class="ml-2">
                            Legacy
                        </b-badge><br>
                                  <small>
                                      {{ formatDate(item.createdDate) }}

                                      <span v-if="item.createdBy">
                                           by {{ item.createdBy }}
                                      </span>
                                  </small>
                    </b-list-group-item>
                </b-collapse>

            </b-list-group>

            <div class="text-center mt-2" v-if="items.length > 1">
                <b-button size="sm" variant="link" @click="showAllHistory = !showAllHistory">
                    {{ showAllHistory ? 'Hide History' : 'Show Previous Changes' }}
                </b-button>
            </div>
        </div>
        <div v-else-if="view == 3"
             style="max-height: 250px; overflow-y: auto;">
            <b-list-group>
                <b-list-group-item v-for="item in items"
                                   :key="item.id"
                                   class="d-flex flex-column">
                    <div>
                        <strong>{{ item.statusPath }}</strong>
                        <b-badge v-if="item.isLegacy"
                                 variant="warning"
                                 class="ml-2">
                            Legacy
                        </b-badge>
                    </div>

                    <div>
                        Reason: {{ item.reasonName || '—' }}
                    </div>

                    <small class="text-muted">
                        {{ formatDate(item.createdDate) }}
                        <span v-if="item.createdBy">
                             by {{ item.createdBy }}
                        </span>

                    </small>
                </b-list-group-item>
            </b-list-group>

        </div>
        <b-list-group v-else>
            <b-list-group-item v-for="item in items"
                               :key="item.id"
                               class="d-flex flex-column">
                <div>
                    <strong>{{ item.statusPath }}</strong>

                    <b-badge v-if="item.isLegacy"
                             variant="warning"
                             class="ml-2">
                        Legacy
                    </b-badge>

                </div>

                <div>
                    Reason: {{ item.reasonName || '—' }}
                </div>

                <small class="text-muted">
                    {{ formatDate(item.createdDate) }}
                    <span v-if="item.createdBy">
                         by {{ item.createdBy }}
                    </span>

                </small>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>
<script>
    export default {
        props: {
            items: {
                type: Array,
                required: true
            },
            view: {
                type: Number,
                required: false,
                default: 0
            }
        },

        data() {
            return {
                showAllHistory: false
            };
        },

        computed: {

            sortedItems() {
                return [...this.items].sort((a, b) =>
                    new Date(b.createdDate) - new Date(a.createdDate)
                );
            },

            visibleHistory() {
                const limit = this.showAllHistory ? this.sortedItems.length : 3;
                return this.sortedItems.slice(0, limit);
            }

        },

        methods: {
            formatDate(dt) {
                return new Date(dt).toLocaleString();
            },

            //formatUser(email) {
            //    return email?.split('@')[0];
            //}
        }
    }
</script>